<template>
	<div id="report-list-view">
		<vx-card :noShadow="true">
			<vx-card :noShadow="true" card-border>
				<div class="flex justify-between flex-wrap">
					<div class="flex justify-start flex-wrap">
						<feather-icon
							icon="FilePlusIcon"
							class="bg-white mr-2 rounded-full"
							svgClasses="w-16 h-16"
						></feather-icon>
						<div class="my-3 ml-3">
							<h5 class="mb-2">
								{{ $t("Reports.ReportType") }} :
								{{ reportSelected ? reportSelected.report_type : "" }}
							</h5>
							<h5>{{ $t("Reports.TotalFiles") }} : {{ dataFiles.length }}</h5>
						</div>
					</div>
					<span>
						<vs-button
							icon-pack="feather"
							icon="icon-arrow-left"
							class="mt-4"
							type="border"
							@click="handleBack"
							>{{ $t("Resource.BackButton") }}</vs-button
						>
					</span>
				</div>
			</vx-card>
			<vs-divider></vs-divider>

			<vs-table
				v-if="dataFiles.length > 0"
				ref="table"
				:multiple="false"
				v-model="selected"
				pagination
				:max-items="itemsPerPage"
				search
				:data="dataFiles"
			>
				<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
					<!-- ITEMS PER PAGE -->
					<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
						<div
							class="
								p-4
								border border-solid
								d-theme-border-grey-light
								rounded-full
								d-theme-dark-bg
								cursor-pointer
								flex
								items-center
								justify-between
								font-medium
							"
						>
							<span class="mr-2"
								>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
								{{
									dataFiles.length - currentPage * itemsPerPage > 0
										? currentPage * itemsPerPage
										: dataFiles.length
								}}
								of {{ queriedItems }}</span
							>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<vs-dropdown-menu>
							<vs-dropdown-item @click="itemsPerPage = 4">
								<span>4</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage = 10">
								<span>10</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage = 15">
								<span>15</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="itemsPerPage = 20">
								<span>20</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>

				<template slot="thead">
					<vs-th sort-key="name">N</vs-th>
					<vs-th sort-key="category">{{ $t("Name") }}</vs-th>
					<vs-th sort-key="order_status">{{ $t("ManualData.AddedOn") }}</vs-th>
					<vs-th>{{ $t("Actions") }}</vs-th>
				</template>

				<template slot-scope="{data}">
					<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td>
								<p class="product-price">{{ tr.id }}</p>
							</vs-td>

							<vs-td>
								<p class="product-category">{{ tr.original_name }}</p>
							</vs-td>

							<vs-td>
								<p class="product-category">{{ tr.added_on }}</p>
							</vs-td>

							<vs-td>
								<feather-icon
									:title="$t('ManualData.DownloadFile')"
									class="ml-2"
									icon="DownloadIcon"
									svgClasses="w-5 h-5 hover:text-primary stroke-current"
									@click.stop="download(tr)"
									ref="BtnSave"
								/>

								<feather-icon
									:title="$t('Crud.Delete')"
									icon="TrashIcon"
									svgClasses="w-5 h-5 hover:text-danger stroke-current"
									class="ml-2"
									@click.stop="openConfirm(tr)"
								/>
							</vs-td>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>

			<div v-else>
				<vs-alert
					:active.sync="activeAlert"
					closable
					icon-pack="feather"
					close-icon="icon-x"
					color="warning"
					:title="$t('Reports.Report')"
				>
					{{ $t("Reports.Report") }}: {{ $route.params.id }} {{ $t("Reports.NoDataReport") }}
				</vs-alert>
			</div>
		</vx-card>
	</div>
</template>

<script>
import vSelect from "vue-select";

import UploadedFile from "@/models/UploadedFile.js";
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleReport from "@/store/report/moduleReport.js";

export default {
	components: {
		vSelect,
	},
	data() {
		return {
			selected: [],
			itemsPerPage: 10,
			isMounted: false,
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 10,
			uploadFile: new UploadedFile({}),
			activeAlert: true,
		};
	},
	computed: {
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		dataFiles() {
			const dataReport = this.$store.getters["moduleReport/getFiles"];
			if (!dataReport) return [];
			return dataReport;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.dataFiles.length;
		},
		reportSelected() {
			return this.$store.getters["moduleReport/getReportByProcessId"](this.$route.params.id);
		},
	},
	methods: {
		handleBack() {
			this.$router.go(-1);
		},
		deleteRecord() {
			const payload = {
				process_id: this.$route.params.id,
				numFile: this.dataItem.id,
			};
			this.openLoading();
			this.$store
				.dispatch("moduleReport/deleteHistoryReport", payload)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Record.DeleteRecord"),
						text: this.$t("Record.TextConfirmRecordDelete"),
					});
					this.closeLoading();
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					this.closeLoading();
				});
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		showDeleteSuccess() {
			this.closeLoading();
			this.$vs.notify({
				color: "success",
				title: this.$t("Record.TitleConfirmRecordDelete"),
				text: this.$t("Record.TextConfirmRecordDelete"),
			});
		},
		openConfirm(dataItem) {
			this.dataItem = dataItem;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Record.DeleteRecord"),
				text: this.$t("Record.DeleteRecordConfirmText"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		download(file) {
			this.openLoading();
			this.uploadFile = new UploadedFile(file);
			if (!this.uploadFile.bucket_path) return;
			downloadFileFromFirebase(this.uploadFile.bucket_path)
				.then(async (res) => {
					const response = await this.uploadFile.downloadFile(this.uploadFile.original_name, res);
					this.$vs.notify({
						color: "success",
						title: this.$t("Notification.DOWNLOAD_FINALIZED"),
						text: `${this.$t("Reports.FileName")} ${this.uploadFile.original_name}`,
						time: 8000,
						fixed: false,
					});
					this.closeLoading();
				})
				.catch((error) => {
					this.closeLoading();
					this.processFirebaseError(error);
				});
		},
		processFirebaseError(error) {
			let msg = "";
			if (error.code && error.code === "storage/object-not-found") {
				msg = `El Archivo ${this.uploadFile.bucket_path} no fue encontrado`;
			} else {
				msg = this.$t("ErrorMessage");
			}
			this.$vs.notify({
				color: "danger",
				title: this.$t("ErrorTitle"),
				text: msg,
				time: 5000,
			});
		},
		async getReportFiles() {
			this.openLoading();
			const payload = {
				filters: {
					process_id: [this.$route.params.id],
				},
				order_by: ["added_on"],
				sort: "desc",
			};
			await this.$store.dispatch("moduleReport/getHistoryReportsFilter", payload);
			this.closeLoading();
		},
	},
	watch: {
		itemsPerPage(val) {
			/*  this.getGroups({page:1, quantity: val}) */
			this.currentPageLocal = 1;
		},
	},
	created() {
		// register Module Group
		if (!moduleReport.isRegistered) {
			this.$store.registerModule("moduleReport", moduleReport);
			moduleReport.isRegistered = true;
		}
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		this.getReportFiles();
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss">
#report-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
